import React from 'react';
import { useDispatch } from 'react-redux';
import { actionType } from 'utils/constants';

import utils from 'utils';
import actions from 'state/actions';

import CommonButton from 'components/Buttons/CommonButton';

const AddCompany = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();

  const setFormModeToCreateCompany = () => {
    dispatch(actions.configurator.setSelectedCompany(null));
    setTimeout(() => {
      dispatch(actions.configurator.setFormModeCompany('new'));
    }, 100);
  };

  return (
    <CommonButton
      id="add-company"
      action={setFormModeToCreateCompany}
      scope="tertiary"
      value={t('AddCompany')}
      customIcon="plus"
      disabled={!utils.user.isActionByCompanyActive(actionType.ADD_COMPANY)}
    />
  );
};

export default AddCompany;
